import * as React from "react";
import { cn } from "@velpha/ui/lib/utils";

export type InputProps = React.ComponentProps<"input">;

function Input({ className, type, ...props }: InputProps) {
  const isFile = type === "file";

  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "border-input focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 disabled:bg-input/50 dark:disabled:bg-input/80 rounded-lg border text-base transition-colors md:text-sm w-full min-w-0 outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 placeholder:text-muted-foreground",
        !isFile && "dark:bg-input/30 h-8 bg-transparent px-2.5 py-1 focus-visible:ring-[3px] aria-invalid:ring-[3px]",
        isFile &&
          cn(
            "dark:bg-input/30 h-10 bg-background px-3 py-2 focus-visible:ring-[3px] aria-invalid:ring-[3px]",
            "file:rounded-md file:border file:border-input file:bg-muted file:px-3 file:text-sm file:font-medium file:text-foreground",
            "hover:file:bg-muted/80 dark:file:bg-muted/30 dark:hover:file:bg-muted/40",
            "text-sm"
          ),
        className
      )}
      {...props}
    />
  );
}

export { Input };
